import { compareTable } from "./compareTable";
import { initShowDifferences } from "./differences";

export const initCompare = async () => {
  initShowDifferences();
  await compareTable();
};